const state = {
  profile: {},
  isEmployeeProfileLoading: true,
  profileLoadError: "",
  isProfileUpdating: false,
  profileUpdateError: "",
};

export default state;
